// extracted by mini-css-extract-plugin
module.exports = {"freight-quotation":"FreightQuotation_freight-quotation__hS03J","container":"FreightQuotation_container__6xn5R"};